
import '$node/hammerjs/hammer.min.js'

export default window.Hammer
